import { render, staticRenderFns } from "./PhilaFooter.vue?vue&type=template&id=2866b113"
import script from "./PhilaFooter.vue?vue&type=script&lang=js"
export * from "./PhilaFooter.vue?vue&type=script&lang=js"
import style0 from "./PhilaFooter.vue?vue&type=style&index=0&id=2866b113&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports